import { DescribeNodeType } from '~/scenes/Automation/Flows/Actions/util/descriptionStandards';

const describeAppValuationReportNewCondition = (): DescribeNodeType =>
  'een nieuw waarderapport is opgevraagd';

export default describeAppValuationReportNewCondition;
